<template>
  <div>
    <div class="information_title">房源描述</div>
    <el-form
      rl-foref="form"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
      label-position="right"
    >
      <el-form-item label="房源标题：" prop="vHousTitle">
        <div class="form_item">
          <div class="form_item_title">
            精炼的介绍特点和优势，让房客在第一时间对你的房源感兴趣
          </div>
        </div>

        <el-input
          class="input_title"
          type="textarea"
          maxlength="60"
          resize="none"
          show-word-limit
          placeholder="请输入内容"
          v-model="form.vHousTitle"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="房源亮点："
        prop="houseInfoSon.vHourHighlight"
        :rules="[
          { required: true, message: '房源亮点不能为空', trigger: 'blur' }
        ]"
      >
        <div class="form_item">
          <div class="form_item_title">
            向房客介绍一下自己房源的特色或服务有哪些
          </div>
        </div>
        <el-input
          maxlength="2000"
          type="textarea"
          resize="none"
          show-word-limit
          placeholder="请输入内容"
          v-model="form.houseInfoSon.vHourHighlight"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="周边情况：">
        <div class="form_item">
          <div class="form_item_title">
            房源所在楼宇和小区的基本情况，以及周边商超、景点、银行、医院等配套设施等情况
          </div>
        </div>
        <el-input
          type="textarea"
          maxlength="2000"
          resize="none"
          show-word-limit
          placeholder="请输入内容"
          v-model="form.houseInfoSon.vSurroundInfo"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="房东留言：">
        <div class="form_item">
          <div class="form_item_title">
            留下一段自己想说的话
          </div>
        </div>
        <el-input
          maxlength="2000"
          type="textarea"
          resize="none"
          show-word-limit
          placeholder="请输入内容"
          v-model="form.houseInfoSon.vHourloadMess"
        >
        </el-input>
      </el-form-item>

      <div class="next_Btn" @click="next_Btn('form')">
        <el-button>保存并继续<i class="el-icon-arrow-right"></i></el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { publishTwoAjax, hourseAuditList } from "../../api/index";

export default {
  props: ["customerId", "isStatus"],
  data() {
    return {
      // 到第几页
      active: 3,
      // 校验
      rules: {
        vHousTitle: [
          { required: true, message: "房源标题不能为空", trigger: "blur" }
        ],
        vHourHighlight: [
          { required: true, message: "房源亮点不能为空", trigger: "blur" }
        ]
      },
      Status: "",
      form: {
        houseId: window.sessionStorage.getItem("hourId") || "",
        vHousTitle: "",
        houseInfoSon: {
          vHourHighlight: "",
          vSurroundInfo: "",
          vHourloadMess: ""
        }
      }
    };
  },
  created() {
      this.$nextTick(()=>{
          document.querySelector(".el-main").scrollTop = 0;
      })
    this.Status = this.isStatus;
    if (this.Status == 1) this.hourseAuditListGet();
  },
  methods: {
    async hourseAuditListGet() {
      try {
        const { data: res } = await hourseAuditList(this.form.houseId);
        if (res.code !== 200)
          return this.$message({
            message: res.msg,
            type: "error"
          });
        this.form.vHousTitle = res.data.hourseInfo.vHousTitle;
        this.form.houseInfoSon.vHourHighlight =
          res.data.hourseInfo.houseInfoSon.vHourHighlight || "";
        this.form.houseInfoSon.vSurroundInfo =
          res.data.hourseInfo.houseInfoSon.vSurroundInfo || "";
        this.form.houseInfoSon.vHourloadMess =
          res.data.hourseInfo.houseInfoSon.vHourloadMess || "";
      } catch (error) {
        console.log(error);
      }
    },
    // 保存并继续
    next_Btn(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const { data: res } = await publishTwoAjax(this.form);
          if (res.code !== 200) {
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.form = {
            houseId: window.sessionStorage.getItem("hourId") || "",
            vHousTitle: "",
            houseInfoSon: {
              vHourHighlight: "",
              vSurroundInfo: "",
              vHourloadMess: ""
            }
          };
          this.$emit("active", this.active);
          return this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          return false;
        }
      });
      // this.$emit("active", this.active);
    }
  }
};
</script>

<style lang="less" scoped>
.information_title {
  height: 66px;
  line-height: 66px;
  margin-top: 30px;
  color: #f6b439;
  font-size: 20px;
  border-bottom: 1px solid #e1e1e1;
}
.next_Btn {
  margin: 90px 0 94px 36px;
  .el-button {
    font-size: 24px;
    color: #fff;
    width: 204px;
    height: 64px;
    background-color: #f6b439;
  }
}
.el-form-item {
  font-size: 18px;
  margin-left: 36px;
  margin-top: 24px;
  .el-select {
    width: 160px;
    height: 50px;
    /deep/.el-input__inner {
      height: 50px;
    }
    /deep/.el-input {
      height: 50px;
    }
  }
  .el-input {
    width: 160px;
    height: 50px;
    margin-left: 100px;
    margin-right: 10px;
    /deep/.el-input__inner {
      height: 50px;
    }
  }
  .el-input:nth-child(2) {
    margin-left: 0px;
  }
  /deep/.el-form-item__label {
    font-size: 18px;
    line-height: 50px;
    color: #000;
  }
}
.form_item {
  overflow: hidden;
  height: 50px;
  .form_item_title {
    float: left;
    height: 40px;
    margin: 5px 190px 20px 0px;
    color: #666666;
    span {
      color: #f6b439;
    }
  }
  .form_item_title:nth-child(2) {
    margin-right: 176px;
  }
}
/deep/.el-textarea__inner {
  width: 958px;
  height: 300px;
}
/deep/.el-textarea {
  width: 950px;
}
.input_title {
  width: 950px;
  height: 150px;
  /deep/.el-textarea__inner {
    width: 958px;
    height: 150px;
  }
}
</style>
